import { Option } from 'effect';

// BE delivers credit/debit as plain float strings ("34324.42", "-31.23") —
// '.' decimal, optional leading '-', no grouping separators (DA-19100). Empty
// cells arrive as "" / null and must be skipped: Number("") is 0, so guard it.
const parseAmount = (raw: unknown): Option.Option<number> => {
  if (typeof raw === 'number') return Number.isFinite(raw) ? Option.some(raw) : Option.none();
  if (typeof raw !== 'string' || raw.trim() === '') return Option.none();

  const parsed = Number(raw.trim());
  return Number.isFinite(parsed) ? Option.some(parsed) : Option.none();
};

export default parseAmount;
